<template>
  <span v-show="show == 1"
        class="transfer">
    <span @click="handleClick">{{ active == 'ch' ? 'English' : 'Chinese'}}</span>
  </span>
</template>
<script>
  export default {
    name: "Transfer",
    data() {
      return {
        active: "ch"
      }
    },
    props: {
      show: {
        type: String,
        default: "0"
      }
    },
    methods: {
      handleClick() {
        this.active = this.active == "ch" ? "en" : "ch"
        this.$emit("change", this.active)
      }
    }
  }
</script>
<style lang="scss">
  .empty_container {
    .text {
      text-align: center;
      padding: 20px;
    }
    .empty {
      background-image: url(../assets/img/empty.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      height: 140px;
      margin: 50px auto 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Transfer.vue